<template>
<list-nav :tabItems="tabItems" :active="active" v-on:active="onNavItemClick" :showSearch="false" />
</template>

<script>
import ListNav from '@/components/general/list-nav'
export default {
  name: 'WalletNav',
  components: {
    ListNav
  },
  props: {
    active: {
      type: String,
      default: () => {
        return this.$t('wallet.all')
      }
    }
  },
  data () {
    return {
      tabItems: [this.$t('wallet.all')],
      keyword: ''
    }
  },
  methods: {
    onNavItemClick (item) {
      this.$emit('active', item)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/wallet/nav.vue